import { render, staticRenderFns } from "./DialogAppointments.vue?vue&type=template&id=5a8aad9a&lang=pug&"
import script from "./DialogAppointments.vue?vue&type=script&lang=js&"
export * from "./DialogAppointments.vue?vue&type=script&lang=js&"
import style0 from "./DialogAppointments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports